// eslint-disable-next-line import/no-anonymous-default-export, import/no-default-export
export default '4.1.0/2024-10-11T19:24';
